import { NgModule } from '@angular/core';
import { ToastrModule } from 'ngx-toastr';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { ngxToastrConfig } from '../../config/toastr.config';

@NgModule({
  declarations: [],
  imports: [
    SweetAlert2Module.forRoot(),
    ToastrModule.forRoot(ngxToastrConfig),
  ],
  exports: [
    SweetAlert2Module,
    ToastrModule
  ]
})
export class NotificationModule {
}
